import { Button, ButtonVariants } from '@triumph/design-system';

import { Dialog } from '@/components/shared/components/Dialog';

interface Props {
    visible: boolean;
    actionLabel: string;
    onConfirm: () => void;
    onClose: () => void;
}

export const ConfirmDebugActionDialog = ({ visible, actionLabel, onConfirm, onClose }: Props) => (
    <Dialog
        id="confirm-debug-action-modal"
        header="Are you sure?"
        visible={visible}
        onHide={onClose}
        dismissableMask={false}
        data-testid="confirm-debug-action-dialog"
    >
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                gap: 20,
                padding: '8px 4px 4px',
                minWidth: 420,
                fontSize: 15,
                lineHeight: 1.5,
            }}
        >
            <div>
                Are you sure you want to <strong>{actionLabel}</strong>?
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                <Button
                    variant={ButtonVariants.secondary}
                    onClick={onClose}
                    data-testid="confirm-debug-action-cancel"
                >
                    Cancel
                </Button>
                <Button
                    variant={ButtonVariants.primary}
                    onClick={onConfirm}
                    data-testid="confirm-debug-action-confirm"
                >
                    {actionLabel}
                </Button>
            </div>
        </div>
    </Dialog>
);
